import React from 'react';
import { withTheme } from 'styled-components';
const TickIcon = ({
  theme,
  width = '20px',
  height = '20px'
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Tick_Selected"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "25",
    height: "25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tick_Selected",
    clipPath: "url(#clip-Tick_Selected)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick_line",
    transform: "translate(1.836 448.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M19.708-443.7c-.193.09-1.11.991-6.578,6.454L6.779-430.9,4.291-433.38c-1.369-1.365-2.553-2.516-2.631-2.557a1.351,1.351,0,0,0-.917,0,1.115,1.115,0,0,0-.514.555,1,1,0,0,0,.033.872c.127.255,5.784,5.912,6.039,6.039a1.339,1.339,0,0,0,.419.111.734.734,0,0,0,.473-.086c.218-.1.88-.744,7.014-6.882s6.783-6.8,6.882-7.014a.741.741,0,0,0,.086-.477,1.044,1.044,0,0,0-.995-.974A.762.762,0,0,0,19.708-443.7Z",
    transform: "translate(0)",
    fill: "#faaa31"
  }))));
};
export default withTheme(TickIcon);